import script from "./SubjectMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectMenu.vue?vue&type=script&setup=true&lang=js"

export default script